import { Eye } from 'lucide-react'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function UserWatchlistHeader() {
  return (
    <Card className="relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-teal-400/10 to-transparent dark:from-teal-400/5 rounded-full -translate-y-8 translate-x-8" />
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-2xl font-bold tracking-tight flex items-center gap-2">
              <Eye className="h-6 w-6 text-teal-600 dark:text-teal-400" />
              Watchlists
            </CardTitle>
            <p className="text-muted-foreground">Create and manage your personal instagram watchlists</p>
          </div>
          <Badge variant="secondary" className="text-xs">
            Monitoring
          </Badge>
        </div>
      </CardHeader>
    </Card>
  )
} 